import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './pages/Languages.css';
import './styles/ArticleComponents.css';
import App from './App';

// The benign "ResizeObserver loop ..." browser notice is NOT a real error: the
// browser emits it when a ResizeObserver callback (here, React Flow's canvas +
// NodeResizer re-measuring) schedules further layout work within the same
// frame. It has no functional impact, but CRA's dev error overlay paints it red.
//
// Root-cause fix: defer every ResizeObserver callback to the next animation
// frame. This breaks the synchronous observe→layout→observe loop so the notice
// is never produced in the first place — more reliable than racing the overlay's
// error handler.
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// Belt-and-suspenders: also swallow the specific benign message if it still
// reaches the window, so the dev overlay never shows it. Genuine errors are
// untouched.
const RESIZE_OBSERVER_NOISE =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener(
  'error',
  (e) => {
    if (e.message && RESIZE_OBSERVER_NOISE.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
